import { render, staticRenderFns } from "./ClientsIndex.vue?vue&type=template&id=fc57d39c&ref=top-parent"
import script from "./clients-index.js?vue&type=script&lang=js&external"
export * from "./clients-index.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports